import React, { FC } from 'react';
import { Button, ButtonProps } from 'antd';
// import { useTranslation } from 'react-i18next';

// import { BravoLogoutIconGrey } from '../styledComponents';
import LogoutIcon from 'assets/images/liHome/log-out.svg';
const LogoutButtonIcon: FC<ButtonProps> = (props) => {
  // const { t } = useTranslation();

  return (
    <Button className="change-lang" shape="circle" {...props}>
      <img src={LogoutIcon} alt="" />
    </Button>
  );
};

export default LogoutButtonIcon;
